import {
  AfterContentInit,
  Component,
  ElementRef,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewEncapsulation,
  inject,
  input,
} from '@angular/core';
import { PostModel } from '@app/src/app/modules/post/classes/default/model/post.model';
import {
  ButtonType,
  dateToTimestamp,
  PROVIDER_NAMES,
  RenderHtml,
  Translation,
} from '@ckmk/angular';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { Router } from '@angular/router';

@Component({
  selector: 'post-card',
  standalone: true,
  imports: [Translation, RenderHtml, FaIconComponent],
  templateUrl: './post-card.html',
  styleUrl: './post-card.scss',
  host: {
    '(click)': 'onClick($event)',
  },
  hostDirectives: [ButtonType],
  encapsulation: ViewEncapsulation.None,
})
export class PostCard
  implements OnInit, OnChanges, OnDestroy, AfterContentInit
{
  protected readonly self = inject<ElementRef<HTMLElement>>(ElementRef);

  protected readonly router = inject(Router);

  protected readonly icons = inject(PROVIDER_NAMES.ICONS);

  public readonly post = input.required<PostModel>();

  public constructor() {}

  public ngOnInit() {}

  public ngOnChanges(changes: SimpleChanges) {}

  public ngOnDestroy() {}

  public ngAfterContentInit() {}

  protected updatedAt(): string {
    return dateToTimestamp(this.post().updatedAt, 'd/m/Y H:i');
  }

  protected onClick(event: MouseEvent): void {
    const post = this.post();

    this.router.navigate(['blog', post.category?.slug, post.slug]).then();
  }
}
